import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck, Check, AlertCircle, ArrowRight } from 'lucide-react';

const COVERED = [
  'Components supplied and installed by LyphLine',
  'Components specifically replaced by LyphLine',
  'Electrical and control work performed by LyphLine',
  'Refrigeration work performed by LyphLine',
  'LyphLine workmanship on the documented retrofit',
];

const NOT_COVERED = [
  'Original components not supplied or replaced by LyphLine',
  'Normal wear and tear',
  'Misuse, improper operation or insufficient maintenance',
  'Incorrect electrical supply, surges or improper grounding',
  'Damage occurring after the machine leaves our control',
  'Third-party repairs or modifications that cause a failure',
];

// Concise, accurate warranty overview used on Process & Rates and the Support page.
// Full legal wording lives on /warranty (WarrantyPolicy).
export const RebuildWarranty = ({ bg = 'bg-white', testid = 'rebuild-warranty', showFullLink = true }) => (
  <section className={`py-20 section-padding ${bg}`} data-testid={testid}>
    <div className="max-w-5xl mx-auto">
      <span className="inline-flex items-center gap-2 text-[#B87333] font-semibold text-xs uppercase tracking-[0.2em]">
        <ShieldCheck className="h-4 w-4" /> Warranty
      </span>
      <h2 className="text-3xl sm:text-4xl font-bold text-[#003456] mt-3">90-day limited retrofit warranty</h2>
      <p className="text-slate-600 mt-5 max-w-3xl leading-relaxed">
        LyphLine repairs, upgrades and retrofits existing freeze dryers. Unless a longer term is stated in
        writing, every retrofit includes a <strong>90-Day Limited Parts &amp; Labour Warranty</strong> covering the
        components and workmanship we supply. The period begins when your machine is returned to service.
      </p>
      <div className="grid md:grid-cols-2 gap-6 mt-10">
        <div className="bg-[#F1F5F9] border border-slate-200 rounded-2xl p-7">
          <h3 className="text-lg font-bold text-[#003456] flex items-center gap-2"><Check className="h-5 w-5 text-[#CE8946]" /> What's covered</h3>
          <ul className="mt-4 space-y-2.5 text-slate-600 text-sm">
            {COVERED.map((t, i) => (
              <li key={i} className="flex items-start gap-2"><Check className="h-4 w-4 text-[#CE8946] mt-0.5 flex-shrink-0" /><span>{t}</span></li>
            ))}
          </ul>
        </div>
        <div className="bg-[#F1F5F9] border border-slate-200 rounded-2xl p-7">
          <h3 className="text-lg font-bold text-[#003456] flex items-center gap-2"><AlertCircle className="h-5 w-5 text-[#B87333]" /> What's not normally covered</h3>
          <ul className="mt-4 space-y-2.5 text-slate-600 text-sm">
            {NOT_COVERED.map((t, i) => (
              <li key={i} className="flex items-start gap-2"><span className="text-[#B87333] mt-0.5 flex-shrink-0">•</span><span>{t}</span></li>
            ))}
          </ul>
        </div>
      </div>
      <p className="text-slate-500 text-sm mt-6 max-w-3xl">
        Retained original parts (vacuum pump, compressor, chamber, heaters, etc.) are not automatically covered
        simply because another portion of the machine was retrofitted.
      </p>
      {showFullLink && (
        <Link to="/warranty" className="inline-flex items-center gap-2 text-[#B87333] font-semibold mt-6 hover:underline" data-testid={`${testid}-full-link`}>
          Read the full Warranty &amp; Support Policy <ArrowRight className="h-4 w-4" />
        </Link>
      )}
    </div>
  </section>
);

export default RebuildWarranty;
